
import _ from 'underscore';
import { transformReportAggregationItself } from '@bingads-webui-campaign/reports-v4-schema';

const partialConversionsColumns = [
  'AllConversions',
  'Conversions',
  'ConversionRate',
  'AllConversionRate',
  'LowQualityConversions',
  'CostPerConversion',
  'ViewThroughCostPerConversion',
  'ViewThroughConversionRate',
  'AllCostPerConversion',
];

function getCorrespondColumnsByReportAggregationEnum(reportAggregationEnum) {
  let columnKeys;
  switch (reportAggregationEnum) {
    case 'Summary':
      columnKeys = [];
      break;
    case 'Hourly':
      columnKeys = ['GregorianDate', 'HourOfDay'];
      break;
    case 'Daily':
      columnKeys = ['GregorianDate'];
      break;
    case 'Weekly':
      columnKeys = ['Week'];
      break;
    case 'Monthly':
      columnKeys = ['Month'];
      break;
    case 'Yearly':
      columnKeys = ['Year'];
      break;
    case 'HourOfDay':
      columnKeys = ['HourOfDay'];
      break;
    case 'DayOfWeek':
      columnKeys = ['DayOfWeek'];
      break;
    case 'WeeklyStartingMonday':
      columnKeys = ['WeekStartingMonday'];
      break;
    default:
      break;
  }
  return columnKeys;
}

/**
 * In old data, user save aggregation in property `ReportAggregation`,
 * but in the new schema, this is a column selected by column chooser.
 * We need to transform the property to a selected column.
 * @param {any} oldTaskItem old back-end data model
 * @returns {any} new back-end data model
 */
function transformReportAggregation(oldTaskItem) {
  if (!oldTaskItem.ReportAggregation) {
    return undefined;
  }
  const reportAggregationEnum = oldTaskItem.ReportAggregation;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { ReportAggregation, ...newTaskItem } = { ...oldTaskItem };
  const newColumnKeys = getCorrespondColumnsByReportAggregationEnum(reportAggregationEnum);
  if (!newColumnKeys) {
    return newTaskItem;
  }
  // Billing statement and invoice billing have no 'TimePeriod' but 'Month' in legacy columns, so add _.uniq to remove duplicate columns
  newTaskItem.ReportColumns = _.uniq([...newColumnKeys, ...newTaskItem.ReportColumns]);
  return newTaskItem;
}

function removeDeprecatedColumns(oldTaskItem) {
  return {
    ...oldTaskItem,
    ReportColumns: oldTaskItem.ReportColumns.filter(column => column !== 'TimePeriod'), // key is "TimePeriod", column name is 'Unit of time'
  };
}

function updatePartialConversions(oldTaskItem) {
  return {
    ...oldTaskItem,
    Filters: oldTaskItem.Filters.map((item) => {
      let expression = item.Filter.Expressions[0];
      if (partialConversionsColumns.includes(expression.PropertyName)) {
        expression = {
          ...expression,
          PropertyName: `${expression.PropertyName}Qualified`,
        };
      }
      return {
        ...item,
        Filter: {
          ...item.Filter,
          Expressions: [expression],
        },
      };
    }),
    ReportColumns: oldTaskItem.ReportColumns
      .map((column) => {
        if (partialConversionsColumns.includes(column)) {
          return `${column}Qualified`;
        }
        return column;
      }),
    ConditionalFormats: oldTaskItem.ConditionalFormats.map((condition) => {
      if (partialConversionsColumns.includes(condition.ColumnName)) {
        return { ...condition, ColumnName: `${condition.ColumnName}Qualified` };
      }
      return condition;
    }),
  };
}

export function convertOldTaskItem(taskItem, permissions) {
  if (!taskItem) {
    throw new Error('taskItem is undefined');
  }
  let newTaskItem = taskItem;
  if (permissions.dynamic.PartialConversions) {
    newTaskItem = updatePartialConversions(newTaskItem);
  }
  // if is task item is in new schema, just return it
  if (taskItem.IsPreview) {
    return newTaskItem;
  }
  newTaskItem = transformReportAggregation(newTaskItem);
  newTaskItem = transformReportAggregationItself(newTaskItem);
  newTaskItem = removeDeprecatedColumns(newTaskItem);
  return newTaskItem;
}
